<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">KD ’000</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font skyBlue">Trade receivables:</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Customers</div>
                    <div data-width='15%' class="font light-gray">306,264</div>
                    <div data-width='15%' class="font">294,906</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Distributors</div>
                    <div data-width='15%' class="font light-gray">42,282</div>
                    <div data-width='15%' class="font">43,909</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Other operators (interconnect)</div>
                    <div data-width='15%' class="font light-gray ">61,177</div>
                    <div data-width='15%' class="font ">48,004</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Roaming partners</div>
                    <div data-width='15%' class="font light-gray"> 7,894</div>
                    <div data-width='15%' class="font">10,408</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">ECL</div>
                    <div data-width='15%' class="font light-gray"> (193,178)</div>
                    <div data-width='15%' class="font">(164,272)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="font white bold ">224,439</div>
                    <div data-width='15%' class="font white bold">232,955</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font skyBlue">Other receivables:</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Accrued income</div>
                    <div data-width='15%' class="font light-gray">5,399</div>
                    <div data-width='15%' class="font">4,884</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Staff</div>
                    <div data-width='15%' class="font light-gray">1,468</div>
                    <div data-width='15%' class="font">1,719</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Deposits and other receivables</div>
                    <div data-width='15%' class="font light-gray  ">56,714</div>
                    <div data-width='15%' class="font ">30,286</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Prepayments and advances</div>
                    <div data-width='15%' class="font light-gray">138,055</div>
                    <div data-width='15%' class="font">132,126</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Others (refer note below)</div>
                    <div data-width='15%' class="font light-gray">155,910</div>
                    <div data-width='15%' class="font">155,499</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">ECL</div>
                    <div data-width='15%' class="font light-gray">(2,699)</div>
                    <div data-width='15%' class="font">(2,071)</div>
                </div>
                <div class="trow light-gray">
                    <div data-width='70%' class="font"></div>
                    <div data-width='15%' class="font white "> 354,847 </div>
                    <div data-width='15%' class="font white">322,443</div>
                </div>
                <div class="trow dark-gray">
                    <div data-width='70%' class="font"></div>
                    <div data-width='15%' class="font white bold ">579,286 </div>
                    <div data-width='15%' class="font white bold">555,398</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font skyBlue">ذمم تجارية مدينة:</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">عملاء</div>
                    <div data-width='15%' class="font light-gray">306,264</div>
                    <div data-width='15%' class="font">294,906</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">موزعون</div>
                    <div data-width='15%' class="font light-gray">42,282</div>
                    <div data-width='15%' class="font">43,909</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">مشغلون آخرون (الربط البيني)</div>
                    <div data-width='15%' class="font light-gray ">61,177</div>
                    <div data-width='15%' class="font ">48,004</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">شركاء تجوال</div>
                    <div data-width='15%' class="font light-gray"> 7,894</div>
                    <div data-width='15%' class="font">10,408</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">الخسارة الائتمانية المتوقعة</div>
                    <div data-width='15%' class="font light-gray"> (193,178)</div>
                    <div data-width='15%' class="font">(164,272)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="font white bold ">224,439</div>
                    <div data-width='15%' class="font white bold">232,955</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font skyBlue">ذمم مدينة أخرى:</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">إيرادات مستحقة</div>
                    <div data-width='15%' class="font light-gray">5,399</div>
                    <div data-width='15%' class="font">4,884</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">موظفون</div>
                    <div data-width='15%' class="font light-gray">1,468</div>
                    <div data-width='15%' class="font">1,719</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">تأمينات وذمم مدينة أخرى</div>
                    <div data-width='15%' class="font light-gray  ">56,714</div>
                    <div data-width='15%' class="font ">30,286</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">مدفوعات مقدماً وسُلف</div>
                    <div data-width='15%' class="font light-gray">138,055</div>
                    <div data-width='15%' class="font">132,126</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">أخرى (انظر أدناه)</div>
                    <div data-width='15%' class="font light-gray">155,910</div>
                    <div data-width='15%' class="font">155,499</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">الخسارة الائتمانية المتوقعة</div>
                    <div data-width='15%' class="font light-gray">(2,699)</div>
                    <div data-width='15%' class="font">(2,071)</div>
                </div>
                <div class="trow light-gray">
                    <div data-width='70%' class="font"></div>
                    <div data-width='15%' class="font white "> 354,847 </div>
                    <div data-width='15%' class="font white">322,443</div>
                </div>
                <div class="trow dark-gray">
                    <div data-width='70%' class="font"></div>
                    <div data-width='15%' class="font white bold ">579,286 </div>
                    <div data-width='15%' class="font white bold">555,398</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>